import { useState, useEffect, useRef } from "react";

const ColorPlusIcon = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <rect x="6" y="24" width="19" height="8" rx="1.5" fill="#4285F4" />
    <rect x="31" y="24" width="19" height="8" rx="1.5" fill="#FBBC04" />
    <rect x="24" y="6" width="8" height="19" rx="1.5" fill="#EA4335" />
    <rect x="24" y="31" width="8" height="19" rx="1.5" fill="#34A853" />
  </svg>
);

export const ContestIllustration = () => (
  <svg width="140" height="120" viewBox="0 0 140 120" fill="none">
    {/* Podium */}
    <rect x="18" y="68" width="30" height="32" rx="3" fill="#dadce0" />
    <text x="33" y="88" textAnchor="middle" fill="#80868b" fontSize="14" fontWeight="600" fontFamily="sans-serif">2</text>
    <rect x="55" y="48" width="30" height="52" rx="3" fill="#FBBC04" opacity="0.7" />
    <text x="70" y="78" textAnchor="middle" fill="#fff" fontSize="14" fontWeight="600" fontFamily="sans-serif">1</text>
    <rect x="92" y="76" width="30" height="24" rx="3" fill="#dadce0" />
    <text x="107" y="92" textAnchor="middle" fill="#80868b" fontSize="14" fontWeight="600" fontFamily="sans-serif">3</text>
    {/* Trophy */}
    <rect x="62" y="18" width="16" height="4" rx="2" fill="#FBBC04" />
    <path d="M64 22 L64 32 Q64 38 70 38 Q76 38 76 32 L76 22Z" fill="#FBBC04" opacity="0.85" />
    <path d="M64 24 Q56 24 56 30 Q56 34 62 34" stroke="#FBBC04" strokeWidth="1.5" fill="none" opacity="0.6" />
    <path d="M76 24 Q84 24 84 30 Q84 34 78 34" stroke="#FBBC04" strokeWidth="1.5" fill="none" opacity="0.6" />
    <rect x="68" y="38" width="4" height="6" rx="1" fill="#FBBC04" opacity="0.7" />
    <rect x="64" y="43" width="12" height="3" rx="1.5" fill="#FBBC04" opacity="0.5" />
    {/* Stars */}
    <circle cx="40" cy="35" r="3" fill="#4285F4" opacity="0.4" />
    <circle cx="105" cy="42" r="2.5" fill="#EA4335" opacity="0.35" />
    <circle cx="25" cy="52" r="2" fill="#34A853" opacity="0.35" />
  </svg>
);

export const BrowseIllustration = () => (
  <svg width="140" height="120" viewBox="0 0 140 120" fill="none">
    {/* Magnifying glass */}
    <circle cx="62" cy="50" r="22" stroke="#5f6368" strokeWidth="2.5" fill="#fff" fillOpacity="0.85" />
    <line x1="78" y1="66" x2="98" y2="86" stroke="#5f6368" strokeWidth="3" strokeLinecap="round" />
    {/* Search result lines inside lens */}
    <rect x="48" y="40" width="20" height="2.5" rx="1" fill="#4285F4" opacity="0.6" />
    <rect x="48" y="46" width="28" height="2" rx="1" fill="#dadce0" />
    <rect x="48" y="52" width="24" height="2" rx="1" fill="#dadce0" />
    <rect x="48" y="58" width="18" height="2" rx="1" fill="#dadce0" />
    {/* Floating cards */}
    <rect x="96" y="22" width="28" height="22" rx="3" fill="#fff" stroke="#dadce0" strokeWidth="1" />
    <rect x="100" y="27" width="14" height="2" rx="1" fill="#34A853" opacity="0.5" />
    <rect x="100" y="32" width="18" height="2" rx="1" fill="#dadce0" />
    <rect x="100" y="37" width="12" height="2" rx="1" fill="#dadce0" />
    <rect x="12" y="30" width="26" height="20" rx="3" fill="#fff" stroke="#dadce0" strokeWidth="1" />
    <rect x="16" y="35" width="12" height="2" rx="1" fill="#EA4335" opacity="0.5" />
    <rect x="16" y="40" width="16" height="2" rx="1" fill="#dadce0" />
    {/* Dots */}
    <circle cx="110" cy="60" r="2" fill="#FBBC04" opacity="0.4" />
    <circle cx="22" cy="70" r="2.5" fill="#4285F4" opacity="0.35" />
  </svg>
);

/* ── 3-dot Menu ── */
const MoreMenu = ({ testId, openMenuId, setOpenMenuId, onShareLink }) => {
  const ref = useRef(null);
  const isOpen = openMenuId === testId;

  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpenMenuId(null);
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [isOpen, setOpenMenuId]);

  return (
    <div ref={ref} style={{ position: "relative", flexShrink: 0 }}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpenMenuId(isOpen ? null : testId);
        }}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "18px",
          color: "#80868b",
          padding: "6px 8px",
          borderRadius: "50%",
          lineHeight: 1,
          transition: "background 0.12s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#e8eaed")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
      >
        ⋮
      </button>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            marginTop: "4px",
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05)",
            minWidth: "160px",
            zIndex: 1000,
            overflow: "hidden",
          }}
        >
          {["Share link", "Delete"].map((label) => (
            <button
              key={label}
              onClick={(e) => {
                e.stopPropagation();
                setOpenMenuId(null);
                if (label === "Share link") onShareLink(testId);
              }}
              style={{
                display: "block",
                width: "100%",
                padding: "10px 16px",
                border: "none",
                background: "none",
                textAlign: "left",
                cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: "13px",
                color: label === "Delete" ? "#d93025" : "#202124",
                transition: "background 0.1s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f3f4")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

/* ── Template Cards ── */
export const BlankCard = ({ onClick }) => {
  const [h, setH] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      className="template-card"
      style={{
        minWidth: "160px",
        maxWidth: "220px",
        flex: "1 0 160px",
        borderRadius: "8px",
        border: "1px solid #dadce0",
        background: "#fff",
        cursor: "pointer",
        overflow: "hidden",
        transition: "box-shadow 0.2s",
        boxShadow: h ? "0 1px 6px rgba(32,33,36,0.14)" : "none",
      }}
    >
      <div
        className="template-image"
        style={{
          height: "160px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "1px solid #e8eaed",
        }}
      >
        <ColorPlusIcon />
      </div>
      <div className="template-text" style={{ padding: "12px 14px 14px" }}>
        <div style={{ fontWeight: 500, fontSize: "14px", color: "#202124" }}>Blank test</div>
      </div>
    </div>
  );
};

export const ImageTemplateCard = ({ title, description, bgColor, illustration, onClick }) => {
  const [h, setH] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      className="template-card"
      style={{
        minWidth: "160px",
        maxWidth: "220px",
        flex: "1 0 160px",
        borderRadius: "8px",
        border: "1px solid #dadce0",
        background: "#fff",
        cursor: "pointer",
        overflow: "hidden",
        transition: "box-shadow 0.2s",
        boxShadow: h ? "0 1px 6px rgba(32,33,36,0.14)" : "none",
      }}
    >
      <div
        className="template-image"
        style={{
          height: "160px",
          background: bgColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "1px solid #e8eaed",
          overflow: "hidden",
        }}
      >
        {illustration}
      </div>
      <div className="template-text" style={{ padding: "12px 14px 14px" }}>
        <div style={{ fontWeight: 500, fontSize: "14px", color: "#202124" }}>{title}</div>
        <div className="template-desc" style={{ fontSize: "12px", color: "#5f6368", marginTop: "3px", lineHeight: 1.4 }}>
          {description}
        </div>
      </div>
    </div>
  );
};

/* ── Test Row ── */
export const TestRow = ({ test, openMenuId, setOpenMenuId, onShareLink, onClick }) => {
  const [h, setH] = useState(false);
  return (
    <div
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      onClick={onClick}
      className="test-row"
      style={{
        display: "flex",
        alignItems: "center",
        padding: "12px 16px",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background 0.12s",
        background: h ? "#f8f9fa" : "transparent",
        gap: "14px",
      }}
    >
      {/* Icon */}
      <div
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "6px",
          background: `${test.color}10`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="2" y="3" width="14" height="2" rx="1" fill={test.color} opacity="0.65" />
          <rect x="2" y="7.5" width="10" height="2" rx="1" fill={test.color} opacity="0.45" />
          <rect x="2" y="12" width="12" height="2" rx="1" fill={test.color} opacity="0.3" />
        </svg>
      </div>

      {/* Title + mobile meta */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontWeight: 500,
            fontSize: "14px",
            color: "#202124",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {test.title}
        </div>
        {/* Second line visible on mobile */}
        <div className="test-row-mobile-meta" style={{ display: "none", fontSize: "12px", color: "#80868b", marginTop: "3px", gap: "6px" }}>
          <span>{test.no_question} Qs</span>
          <span>·</span>
          <span>{test.duration}</span>
          <span>·</span>
          <span>{test.submitted}</span>
        </div>
      </div>

      {/* Desktop meta */}
      <span className="test-row-desktop-meta" style={{ fontSize: "13px", color: "#5f6368", flexShrink: 0, width: "90px" }}>
        {test.no_question} questions
      </span>
      <span className="test-row-desktop-meta" style={{ fontSize: "13px", color: "#5f6368", flexShrink: 0, width: "60px" }}>
        {test.duration}
      </span>
      <span className="test-row-desktop-meta" style={{ fontSize: "12px", color: "#80868b", flexShrink: 0, width: "100px", textAlign: "right" }}>
        {test.submitted}
      </span>

      <div onClick={e => e.stopPropagation()}>
        <MoreMenu testId={test.id} openMenuId={openMenuId} setOpenMenuId={setOpenMenuId} onShareLink={onShareLink} />
      </div>
    </div>
  );
};


const COLORS = ["#4285F4", "#34A853", "#FBBC04", "#EA4335"];

const pickColor = () => COLORS[Math.floor(Math.random() * COLORS.length)];

export function formatTimestamp(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function mapTests(rawTests) {
  return rawTests.map(t => ({
    id: t.id,
    title: t.name,
    subject: t.detail?.subject ?? "General",
    questions: t.questions,
    no_question: t.questions?.length ?? 0,
    submitted: formatTimestamp(t.created_at),
    color: pickColor(),
  }));
}